export default "__VITE_ASSET__wlOXb1gR__"